import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { Box, Chip } from "@mui/material";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import MainApi from "../../../../../../services/mainApi.service";
import { IAutomationRecRuleTicketDefDoc } from "../../../../../../models/automation-rec-rule-ticket-def-doc";
import { useCallback, useMemo, useState } from "react";
import AutomationRecRuleTicketDefDoc from "./AutomationRecRuleTicketDefDocForm/AutomationRecRuleTicketDefDoc";

const TICKET_AUT_REC_RULE_TICKET_DEF_DOC_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutRecRuleTicketDefDoc/";
const ticketAutomationReceivedCustomMessageService =
  new MainApi<IAutomationRecRuleTicketDefDoc>(
    TICKET_AUT_REC_RULE_TICKET_DEF_DOC_ROUTE,
  );

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationRecRuleTicketDefDoc.";

const AutomationRecRuleTicketDefDocPage = ({
  automationCode,
}: {
  automationCode?: string;
}) => {
  const { t } = useTranslation();

  const { id: ticketAutomationReceivedRuleId } = useParams();

  const [timeRuleForm, setTimeRuleForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const columns: GridColDef<IAutomationRecRuleTicketDefDoc>[] = [
    {
      field: "sendWhen",
      headerName: t(translationPath + "send_when") || "Send When",
      flex: 1,
      minWidth: 200,
      renderCell: ({ row: { sendWhen } }) => {
        if (!sendWhen.name) return "-";
        return <OverflowTooltip text={sendWhen.name} tooltip={sendWhen.name} />;
      },
    },
    {
      field: "description",
      headerName: t(translationPath + "description") || "Description",
      renderCell: (params) => {
        if (!params.value) return "-";
        return params.value;
      },
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 150,
      renderCell: (params) => (
        <Chip
          size="small"
          label={
            params.value
              ? t(translationPath + "active")
              : t(translationPath + "inactive")
          }
          color={params.value ? "success" : "error"}
        />
      ),
    },
  ];

  const handleAdd = () => {
    setTimeRuleForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<IAutomationRecRuleTicketDefDoc>,
  ) => {
    if (!params.row) return;
    setTimeRuleForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setTimeRuleForm(false);
  }, []);

  const props = useMemo(() => {
    return {
      TicketAutomationReceivedRuleId: ticketAutomationReceivedRuleId,
    };
  }, [ticketAutomationReceivedRuleId]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {timeRuleForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <AutomationRecRuleTicketDefDoc
            id={selectedId}
            ticketAutomationReceivedRuleId={ticketAutomationReceivedRuleId}
            automationCode={automationCode}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!timeRuleForm && (
        <Box height={600}>
          <Table<IAutomationRecRuleTicketDefDoc>
            showDefaultMacroFilters={false}
            service={ticketAutomationReceivedCustomMessageService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            defaultPageSize={20}
            serviceProps={props}
            pageSizeOptions={[5, 10, 20]}
            searchInputPlaceHolder={""}
            addButtonLabel={
              t(translationPath + "add_ticket_default_doc") ||
              "Add Custom Message"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default AutomationRecRuleTicketDefDocPage;
